import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { EndpointsService, NotificationService } from "../core/services";

@Injectable()
export class CreativesService {
    private static notificationService;
    constructor(private http: Http, private endpointsService: EndpointsService, private notificationService: NotificationService) {
        CreativesService.notificationService = notificationService;
    }

    public getFilteredCreatives(sortFieldId: number, sortAsc: boolean, pageNumber: number, pageSize: number, name: string, publisherIds: number[]): Observable<Response> {
        let url = this.getCreativesUrl(sortFieldId, sortAsc, pageNumber, pageSize, name, publisherIds);
        return this.http.get(url)
            .catch(this.handleError);
    }

    public getProvidersForPublisher(publisherId: number) {
        let url = `${this.endpointsService.GET_PROVIDERS_FOR_PUBLISHER_URL}?publisherId=${publisherId}`;
        return this.http.get(url)
            .catch(this.handleError);
    }

    public getCountriesForPublisherAndProvider(publisherId: number, providerId?: number) {
        let url = `${this.endpointsService.GET_COUNTRIES_FOR_PUBLISHER_AND_PROVIDER_URL}?publisherId=${publisherId}&providerId=${providerId}`;
        return this.http.get(url)
            .catch(this.handleError);
    }

    public createCreative(name: string, startDateUtc: string, endDateUtc: string, position: number,
        publisherId: number, publisherName: string, selectedCountries: string,
        targetAudiences: string, file: File, providerId?: number): Observable<Response> {
        let headers = new Headers();
        headers.append('Accept', 'application/json');
        let formData: FormData = new FormData();
        let providerIdentifier = '';
        if (providerId) providerIdentifier = providerId.toString();
        formData.append('uploadFile', file, file.name);
        formData.append('name', name);
        formData.append('position', position.toString());
        formData.append('startDateUtc', startDateUtc);
        formData.append('endDateUtc', endDateUtc);
        formData.append('publisherId', publisherId.toString());
        formData.append('publisherName', publisherName);
        formData.append('providerId', providerIdentifier);
        formData.append('countryIds', selectedCountries);
        formData.append('targetAudiences', targetAudiences);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(this.endpointsService.CREATE_CREATIVE_URL, formData, options)
            .catch(this.handleError);
    }

    private getCreativesUrl(sortFieldId: number, sortAsc: boolean, pageNumber: number, pageSize: number, name: string, publisherIds: number[]): string {
        return `${this.endpointsService.GET_CREATIVES_URL}?sortFieldId=${sortFieldId}&sortAsc=${sortAsc}&name=${name}&publisherIds=${publisherIds}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    }

    private handleError(error: Response) {
        if (error.status === 400)
            CreativesService.notificationService.showError(error.json().message)
        else
            CreativesService.notificationService.showError();
        return Observable.throw(error.json().error || 'Server Error');
    }
}


// WEBPACK FOOTER //
// ./src/app/creatives/creative.services.ts